import { withAuth } from '../../auth/withAuth';
import { AssignmentEndPage } from './AssignmentEndPage';

const AssignmentEndPageWithAuth = withAuth(AssignmentEndPage);

export default AssignmentEndPageWithAuth;
